import * as React from 'react';

import { useIntl } from 'react-intl';

import ActionButton from 'components/action-button';
import { useAuthContext } from 'state/auth';
import { region } from 'utils/environment';
import { Region } from 'utils/environment/types';
import { routes } from 'utils/routing';

import {
  ButtonContainer,
  HeaderAndLogoContainer,
  HeaderContainer,
  HistorySignUpContainer,
  NormalText,
  StyledLink,
  StyledRewardsLogo,
} from './history-sign-up.styled';

export const HistorySignUp: React.FC = () => {
  const { formatMessage } = useIntl();
  const { openSignInModal } = useAuthContext();
  const isCanada = region === Region.CA;

  return (
    <HistorySignUpContainer testID="history-sign-up-card">
      <HeaderAndLogoContainer>
        <StyledRewardsLogo />
        <HeaderContainer>
          <NormalText>{formatMessage({ id: 'loyaltyHistorySignUp' })}</NormalText>
        </HeaderContainer>
      </HeaderAndLogoContainer>
      <ButtonContainer>
        <ActionButton fullWidth onPress={() => openSignInModal()}>
          {formatMessage({ id: 'signInUp' })}
        </ActionButton>
        <StyledLink to={isCanada ? routes.bkRewards : routes.royalPerks}>
          {formatMessage({ id: 'learnMore' })}
        </StyledLink>
      </ButtonContainer>
    </HistorySignUpContainer>
  );
};
